import { Injectable } from '@angular/core';
import { UtilService } from '../util.service';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { MeetingInfo } from 'src/app/models/meetings/meeting.model';

@Injectable({
  providedIn: 'root',
})
export class MeetingService {
  readonly rootURL = environment.ImpataAppAPIRoot;
  req_headers = new HttpHeaders({
    'content-type': 'application/json',
    accept: 'application/json',
  });
  constructor(private http: HttpClient, private util: UtilService) {}

  createMeetingLink(data) {
    return this.http.post(this.rootURL + `meeting/generatemeetingid`, data);
  }
  getMeetingInfo(meetingId: string) {
    return this.http.get(
      this.rootURL + `meeting/getmeetingauth?meetingId=${meetingId}`
    );
  }
  getMeetingAttendance(meetingId: string) {
    return this.http.get(
      this.rootURL + `meeting/getmeetinngattendance?meetingId=${meetingId}`
    );
  }
}
